import {flushSync} from "react-dom";
import React, {useEffect, useMemo, useRef, useState} from "react";
import {text} from '../../shared/utils/i18n';
import Cookies from 'js-cookie';
import parse from 'html-react-parser';
import {createRoot} from "react-dom/client";
import {getAndStripAttribute} from "../../shared/utils/dom-container-util";

const CONTEXT_PRODUCT = 'PRODUCT';
const CONTEXT_BLOG = 'BLOG';
const CONTEXT_OTHER = 'OTHER';

function resolveSetRecentSearchCookie(e, context, linkUrl) {
    if (context === "link") {
        document.location.href = linkUrl;
    } else {
        e.target.submit();
    }
}

function setRecentSearchCookie(e, context, title, linkUrl, captureText, contextPath) {
    e.preventDefault();
    showLoadingSpinner();
    if (captureText) {
        requestAnimationFrame(() => {
            fetch(`${contextPath}/search/save-content-recent-search?title=${title}`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then(resolveSetRecentSearchCookie(e, context, linkUrl));
        });
    } else {
        resolveSetRecentSearchCookie(e, context, linkUrl);
    }
}

const RenderQuickSearchResults = (props) => {
    const { searchText, contextPath, context, setContext, searchResultData, setSearchResultData ,resetHeaderSearch} = props;

    useMemo(() => {
        showLoadingSpinner();

        requestAnimationFrame(() => {
            fetch(`${contextPath}/search/quicksearch?text=${searchText}`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then(res => res.json())
                .then(data => {
                    setSearchResultData(data);
                    hideLoadingSpinner();
                });
        });
    }, [searchText]);

    const ShowProductResults = (props) => {
        const { searchProducts } = props;
        return searchProducts.map((product, i) => {
            if (i < 8) {
                return (
                    <a href={`${contextPath}${product.productUrl}`} className="product-basic" key={i} onClick={(e) => setRecentSearchCookie(e, "link", `${product.productName}`, `${contextPath}${product.productUrl}`, true, contextPath)}>
                        <div className="product-basic__image">
                            <img src={`${(product.image === null || product.image === "") ? "/_ui/desktop/common/assets-doterra/images/prod-unavailable.png": product.image}`} alt={product.productName} />
                        </div>
                        <div className="product-basic__body">
                            <h3 className="product-basic__title result-title" data-sku={product.code}>
                                {parse(product.productName)}
                            </h3>
                            <div className="product-basic__row">
                                <div className="product-basic__costs">
                                    <div className="product-basic__total">
                                        {product.price.formattedValue !== null ? product.price.formattedValue : ''}
                                    </div>
                                </div>
                                <div className="product-basic__type">
                                    <span>{product.categories !== null ? product.categories[0] : text('text.header.main.quick.search.product.nocategory')}</span>
                                </div>
                            </div>
                        </div>
                    </a>
                );
            }
        });
    };

    const ShowBlogContentType = (props) => {
        const { contentType } = props;
        let blogType;

           if (contentType && contentType.indexOf(' -') >= 0) {
              blogType = <div className="card__category">
                <span className="category__parent">{contentType.substring(0, contentType.indexOf(' -'))}</span> /
                <span className="category__child">{contentType.substring(contentType.indexOf('- ') + 2)}</span>
              </div>;
           } else {
                  blogType = <div className="card__category"><span>{contentType}</span></div>;
           }

        return blogType;
    };

    const ShowBlogResults = (props) => {
        const { searchBlog } = props;
        return (
            <>
                <h2 className="search-panel__section-heading">
                    {text('text.header.main.quick.search.blog.relatedarticles')} ({searchResultData.blogCount})
                </h2>
                <div className="cards cards-blog cards--list cards--col-1 cards--col-sm-2 cards--col-md-2">
                    {searchBlog.map((blogPage, i) => {
                        if (i < 6) {
                            return (
                                <div className="card card--sm card-blog card-blog--list" key={i}>
                                    <a href={`${contextPath}${blogPage.pageUrl}`} className="product-basic" onClick={(e) => setRecentSearchCookie(e, 'link', `${blogPage.pageTitle}`, `${contextPath}${blogPage.pageUrl}`, true, contextPath)}>
                                        <div className="card__image"
                                             style={{backgroundImage: `url(${blogPage.image})`}}/>
                                        <div className="card__body">
                                            <ShowBlogContentType contentType = {blogPage.internalContentType ? blogPage.internalContentType : "" } />

                                            <h5 className="card__heading result-title">
                                                {parse(blogPage.pageTitle)}
                                            </h5>
                                            <div className="card__meta">
                                                <div className="card__meta__date">{blogPage.formattedDate}</div>
                                            </div>
                                            <p className="card__excerpt">{blogPage.displayPageDescription}</p>
                                        </div>
                                    </a>
                                </div>
                            );
                        }
                    })}
                </div>
            </>
        );
    };

    const ShowOtherResults = (props) => {
        const { searchOther } = props;
        return (
            <div className="cards cards-media cards--list cards--col-1 cards--col-sm-2 cards--col-md-3">
                {searchOther.map((otherPage, i) => {
                    if (i < 9) {
                        return (
                            <div className="card card-blog" key={i}>
                                <a href={`${contextPath}${otherPage.pageUrl}`} style={{color: 'inherit'}} className="product-basic" onClick={(e) => setRecentSearchCookie(e, 'link', otherPage.pageTitle, `${contextPath}${otherPage.pageUrl}`, true, contextPath)}>
                                    <div className="card__body">
                                        <h5 className="card__heading result-title">
                                            {parse(otherPage.pageTitle)}
                                        </h5>
                                        <p className="card__excerpt">{otherPage.displayPageDescription}</p>
                                        <div className="card-other__type">
                                            <div className="card__category">
                                                <span>{otherPage.internalContentType}</span>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        );
                    }
                })}
            </div>
        );
    };

    function renderSearchBody(context) {
        const blogResults = searchResultData.searchData.contentPageList.filter((contentPage) =>
                                                                               { return contentPage.contentType.toLowerCase().includes('blog');});
        const otherResults = searchResultData.searchData.contentPageList.filter((contentPage) =>
                                                                                { return !contentPage.contentType.toLowerCase().includes('blog');});
        switch(context) {
            case CONTEXT_PRODUCT:
                return <ShowProductResults searchProducts={searchResultData.searchData.productSearchResult.productList} />;
            case CONTEXT_BLOG:
                return <ShowBlogResults searchBlog={blogResults} />;
            case CONTEXT_OTHER:
                return <ShowOtherResults searchOther={otherResults} />;
        }
    }

    return (
        <div className="search-panel d-flex justify-content-center row">
            <div className="col-lg-10 ">
                <div className="search-panel__filters">
                    <ul className="nav nav-pills" id="search-pills" role="tablist">
                        <li className="nav-item">
                            <a role="tab" tabIndex="0" className={`btn btn-tertiary${context === CONTEXT_PRODUCT ? ' active' : ''}`} id="pills-product-tab" onClick={() => setContext(CONTEXT_PRODUCT)}>
                                {text('text.header.main.quick.search.product.pill')} ({searchResultData.searchData.productSearchResult.numberOfProducts})
                            </a>
                        </li>
                        <li className="nav-item">
                            <a role="tab" tabIndex="0" className={`btn btn-tertiary${context === CONTEXT_BLOG ? ' active' : ''}`} id="pills-blog-tab" onClick={() => setContext(CONTEXT_BLOG)}>
                                {text('text.header.main.quick.search.blog.pill')} ({searchResultData.blogCount})
                            </a>
                        </li>
                        <li className="nav-item">
                            <a role="tab" tabIndex="0" className={`btn btn-tertiary${context === CONTEXT_OTHER ? ' active' : ''}`} id="pills-other-tab" onClick={() => setContext(CONTEXT_OTHER)}>
                                {text('text.header.main.quick.search.other.pill')} ({searchResultData.otherCount})
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="tab-content" id="search-pills-tabContent">
                    <div className="tab-pane fadeshow active" id={`pills-${context.toLowerCase()}`} role="tabpanel" aria-labelledby={`pills-${context.toLowerCase()}-tab`}>
                        <div className="scroller">
                            <div className="search-panel__body">
                                {renderSearchBody(context)}
                            </div>
                        </div>
                        <div className="search-panel__footer"
                            onKeyDown={(e) => {
                                if(!e.shiftKey && e.key === "Tab") {
                                    resetHeaderSearch();
                                }
                            }}>
                            <a href={`${contextPath}/search/fullsearch?text=${searchText}&contentType=${context}&saveSearch=true`} className="btn btn-primary">
                                {text('text.header.main.quick.search.product.showallresults')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const RenderRecentSearches = (props) => {
    const { recentSearches } = props;

    function decodeURIComponentSafe(s) {
        if (!s) {
            return s;
        }
        return decodeURIComponent(s.replace(/%(?![0-9][0-9]+)/g, '%25'));
    }

    return recentSearches.filter((value, index, self) => {
        return self.indexOf(value) === index;
    }).map((recentSearch, i) => {
        const encodedSearchValue = encodeURI(recentSearch).replace(/#/g, '%23').replace(/&/g, '%26').replace(/@plus/g, '%2B');
        const displaySearchValue = decodeURIComponentSafe(recentSearch.replace(/\+/g, '%20').replace(/@plus/g, '+'));

        return (
            <li key={i} className="search__history__item">
                <a className="search__history__link" href={`${contextPath}/search/fullsearch?text=${encodedSearchValue}&contentType=PRODUCT`}>{displaySearchValue}</a>
            </li>
        );
    });

};

const HeaderQuickSearchContainer = (props) => {
    const { contextPath, inputPlaceholder } = props;
    const [searchText, setSearchText] = useState('');
    const [searchActive, setSearchActive] = useState(false);
    const [recentSearches, setRecentSearches] = useState([]);
    const [context, setContext] = useState(CONTEXT_PRODUCT);
    const searchInputRef = useRef(null);
    const searchDropdownRef = useRef(null);
    const [hasSearchResults, setHasSearchResults] = useState(false);
    const [searchResultData, setSearchResultData] = useState({
        "blogCount": 0,
        "hideAddToCart": false,
        "otherCount": 0,
        "searchData": {
            "totalCount": null,
            "headerText": "type.ExternalSearchDoterraContentTypesEnum.ALL.name Found (1)",
            "allResultsText": null,
            "numberOfPages": 0,
            "paginationEnabled": false,
            "productSearchResult": {
                "carouselNavEnabled": false,
                "productList": [],
                "numberOfProducts": 0
            },
            "contentPageList": [],
            "navigationList": [],
            "internalNavigationList": [],
            "contentFilterList": []
        }
    });

    function handleSetContext(newContext) {
      flushSync(() => {
        setContext(newContext);
      });
    }

    function handleSetSearchResultData(newData) {
      flushSync(() => {
        setSearchResultData(newData);
      });
    }

    function getSearchesFromCookie(searchText){
        $("body").addClass("search-active");

        if(Cookies.get("RecentSearches") && searchText.length === 0) {
            const recentSearchItems = Cookies.get("RecentSearches").split("::");
            if (recentSearchItems.length) {
              flushSync(() => {
                setRecentSearches(recentSearchItems);
              });
            }
        }
    }

    function resetHeaderSearch() {
      flushSync(() => {
        setSearchActive(false);
        setSearchText('');
      });
        $("body").removeClass("search-active");
    }

    useEffect(() => {
        function handleClickOutside(event) {
            if ((searchInputRef.current && !searchInputRef.current.contains(event.target)) && (searchDropdownRef.current && !searchDropdownRef.current.contains(event.target))) {
                resetHeaderSearch();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [searchInputRef]);

    useMemo(() => {
        if (searchResultData.blogCount > 0 || searchResultData.otherCount > 0 || searchResultData.searchData.productSearchResult.numberOfProducts > 0) {
            setHasSearchResults(true);
        } else {
            setHasSearchResults(false);
        }
    }, [searchResultData]);

    return (
        <>
            <form id="site-search" className="header__search-form" action={`${contextPath}/search/fullsearch`} method="GET" onSubmit={(e) => setRecentSearchCookie(e, 'form', `${searchText}`, null, hasSearchResults, contextPath)}>
                <input id="header_save_search" name="saveSearch" type="hidden" value="false"/>

                <div id="header_search_group" className={`form-group${searchActive ? ' active': ''}`}>
                    <label htmlFor="header_search_input" className="u--visuallyhidden">{inputPlaceholder}</label>
                    <input ref={searchInputRef} type="text" className="form-control" id="header_search_input" aria-label={searchText.length >= 3 ? localText["search.nav.auto.suggestion"]:'' } required name="text" value={searchText} maxLength="150"
                           placeholder={inputPlaceholder} autoComplete="off" onChange={e => setSearchText(e.target.value)}
                           onFocus={(e) => {
                                getSearchesFromCookie(e.target.value);
                                setSearchActive(true);
                            }}
                            onKeyDown={(e) => {
                                if(e.shiftKey && e.key === "Tab") {
                                    resetHeaderSearch();
                                }
                            }}
                            />
                    <input id="contentType" name="contentType" type="hidden" value={context} />
                    <button id="header_search_button" type="button" className={`btn btn--icon btn--search`} onClick={() => searchActive ? resetHeaderSearch() : searchInputRef.current.focus()}>{searchActive ? localText["search.nav.clear.results"]:localText["search.placeholder"] }</button>
                </div>
            </form>

            <div ref={searchDropdownRef} className={`menu-dropdown menu-dropdown--search${searchActive ? ' active' : ''}`} data-mega-name="search">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            {searchText.length === 0 && searchActive && recentSearches.length > 0 &&
                                <div className="search__history">
                                    <div className="search__history--heading">
                                        {text('text.search.recent.searches')}
                                    </div>
                                    <ul className="search__history__list">
                                        <RenderRecentSearches recentSearches={recentSearches} />
                                    </ul>
                                </div>
                            }

                            {searchText.length >= 3 && <RenderQuickSearchResults searchText={searchText} contextPath={contextPath} context={context} setContext={handleSetContext} searchResultData={searchResultData} setSearchResultData={handleSetSearchResultData} resetHeaderSearch={resetHeaderSearch}/>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const domContainerId = '#header-quick-search-container';
const domContainer = document.querySelector(domContainerId);
if (domContainer) {
  const contextPath = getAndStripAttribute('data-context-path', domContainer);
  const placeholder = getAndStripAttribute('data-placeholder', domContainer);
  const root = domContainer ? createRoot(domContainer) : false;
  root.render(<HeaderQuickSearchContainer contextPath={contextPath} inputPlaceholder={placeholder} />);
}


